import React from 'react'
import Header from '../component/Header'
import Footer from '../component/Footer'
import Banner from '../component/Banner'
import Aboutinner from '../component/Aboutinner'

function About() {

return (
    <div>
        <>
            <Aboutinner/>
        </>
    </div>
  )
}

export default About
